import { Box, Circle, Flex, FlexboxProps, keyframes, Stack } from '@chakra-ui/react'
import { H3 } from 'components/typography'
import { useRouter } from 'next/router'
import { FC } from 'react'

const scrollerData = [
  'Pagamento 100% seguro',
  'Seus dados estão protegidos (LGPD)',
  'ANVISA regulamentado',
  'Telemedicina autorizada no Brasil'
]

const scrollerDataGads = ['Pagamento 100% seguro', 'Seus dados estão protegidos (LGPD)', 'Regulamentado pela ANVISA']

const MedleveScrollingBannerSection: FC = () => {
  return (
    <Box bg="alabaster" px="24px">
      <Box h={{ base: '56px', lg: '80px' }} overflow="hidden" rounded="full" maxWidth="1310px" mx="auto" bg={'medleve'}>
        <AutoScroller />
      </Box>
    </Box>
  )
}

export default MedleveScrollingBannerSection

const AutoScroller: FC = () => {
  const router = useRouter()
  const isGads = router.pathname.includes('gads')
  const data = isGads ? scrollerDataGads : scrollerData
  const movePrimary = keyframes`
  from { left: 0%; }
  to { left: -100%; }
  `
  const moveSecondary = keyframes`
  from { left: 100%; }
  to { left: 0%; }
  `
  const animationPrimary = `${movePrimary} 12s linear infinite`
  const animationSecondary = `${moveSecondary} 12s linear infinite`

  return (
    <Box>
      <Stack
        w={{ base: isGads ? '800px' : '1000px', lg: isGads ? '1100px' : '1350px' }}
        position="relative"
        spacing="0"
      >
        <ScrollElement data={data} animation={animationPrimary} />
        <ScrollElement data={data} animation={animationSecondary} />
      </Stack>
    </Box>
  )
}

interface TextItemProps {
  text: string
}

const TextItem: FC<TextItemProps> = ({ text }) => (
  <Flex gap={4} alignItems="center" whiteSpace="nowrap">
    <Circle size={2} bg={'alabaster'} />
    <H3
      color="alabaster"
      fontWeight={800}
      fontSize={{ base: '15px', lg: '20px' }}
      letterSpacing={{ base: '-0.6px', lg: '-0.15px' }}
      lineHeight={{ base: '20px', lg: '24px' }}
    >
      {text}
    </H3>
  </Flex>
)

interface ScrollElementProps extends FlexboxProps {
  animation: string
  data: string[]
}

const ScrollElement: FC<ScrollElementProps> = ({ animation, data }) => (
  <Flex
    w="full"
    animation={animation}
    gap="32px"
    px={4}
    py={{ base: '13px', lg: '25px' }}
    position="absolute"
    top="0%"
    left="0%"
  >
    {data.map((item, index) => (
      <TextItem key={index} text={item} />
    ))}
  </Flex>
)
